import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PROVIDER_LABELS, type SimProfile, type SimProvider } from "@/lib/sims";

const NO_PROFILE = "__none__";

/** Picks a profile of the given providers, or "No profile". */
export function SimProfileSelect({
  profiles,
  providers,
  value,
  onChange,
  disabled,
  testId,
}: {
  profiles: SimProfile[];
  providers: SimProvider[];
  value: string | null;
  onChange: (profileId: string | null) => void;
  disabled?: boolean;
  testId?: string;
}) {
  return (
    <Select
      value={value ?? NO_PROFILE}
      onValueChange={(v) => onChange(v === NO_PROFILE ? null : v)}
      disabled={disabled}
    >
      <SelectTrigger data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NO_PROFILE}>No profile</SelectItem>
        {providers.map((provider) => {
          const options = profiles.filter((p) => p.provider === provider);
          if (options.length === 0) return null;
          return (
            <SelectGroup key={provider}>
              <SelectLabel>{PROVIDER_LABELS[provider]}</SelectLabel>
              {options.map((p) => (
                <SelectItem key={p.id} value={p.id}>
                  {p.name}
                </SelectItem>
              ))}
            </SelectGroup>
          );
        })}
      </SelectContent>
    </Select>
  );
}
